import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  media: {
    borderRadius: '20px',
    objectFit: 'cover',
    maxWidth: '100%',
  },
  card: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      flexDirection: 'column',
      '& *':{maxWidth: '300px',},
    },
  },
  section: {
    borderRadius: '20px',
    margin: '10px',
    minWidth: '500px',
    flex: 1,
  },
  imageSection: {
    '&:hover':{
      cursor: "pointer",
    },
    '& #row':{
      width: '100%',
    },
    marginLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  recommendedPosts: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  loadingPaper: {
    display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', borderRadius: '15px', height: '39vh',
  },
  message:{
      fontSize: 20,
      padding: '10px',
  },
}));
